import { render, staticRenderFns } from "./ParentDailyDiary.vue?vue&type=template&id=3b3b30b6&"
import script from "./ParentDailyDiary.vue?vue&type=script&lang=js&"
export * from "./ParentDailyDiary.vue?vue&type=script&lang=js&"
import style0 from "./ParentDailyDiary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports